<div class="row">
  <div class="col-12">
    <div class="card w-100">
      <div class="card-body">
        <div class="row">
          <div class="col-12 d-flex flex-row justify-content-between">
            <h4>{{ 'pages.transport.detail-page.event-history.headline' | translate }}</h4>
            <div>
              <p-button
                icon="pi pi-angle-up"
                (onClick)="toggleComponentCollapse()"
                class="collapse-arrow"
                [class.collapsed]="isComponentCollapsed()"
                [rounded]="true"
                size="large"
                variant="text"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 col-lg-3 border-md-end mt--24">
            <div class="d-flex flex-column">
              <myarvato-data-field [label]="'Estimated Delivery Date'" [data]="details().eventInfo.eta | dayjs" />
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-3 border-md-end mt--24">
            <div class="d-flex flex-column ml-md--16">
              <myarvato-data-field [label]="'Delayed'" [data]="details().eventInfo.daysDelayed | localizedNumber" />
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-3 mt--24">
            <div class="d-flex flex-column ml-md--16">
              <myarvato-data-field [label]="'Last Updated'" [data]="details().eventInfo.lastUpdate! | daysAgo" />
            </div>
          </div>
        </div>

        @if (!isComponentCollapsed()) {
          <div @collapseAnimation>
            <div class="row">
              <div class="col-12 mt--32 mb--16">
                @if (!isEmptyState()) {
                  <p-timeline [value]="timelineItems()" [align]="timelineAlign()" styleClass="event-history__timeline">
                    <ng-template #marker let-item>
                      <div class="event-history__timeline__marker">
                        <span
                          class="event-history__timeline__marker-icon"
                          [ngClass]="['is-' + item.severityClass, 'event-history__timeline__marker-icon--' + item.markerAppearance]"
                        >
                          @if (item.iconClass) {
                            <i [ngClass]="item.iconClass"></i>
                          }
                        </span>
                      </div>
                    </ng-template>
                    <ng-template #content let-item>
                      @if (item.event.$type === 'EventDto') {
                        <transport-event [eventData]="item.event" class="mt--16 mb--16" />
                      }
                      @if (item.event.$type === 'CommentDto') {
                        <transport-comment [eventData]="item.event" class="mt--16 mb--16" [side]="item.side" />
                      }
                      @if (item.event.$type === 'ExceptionStatusChangeDto') {
                        <transport-exception-status-change [eventData]="item.event" class="mt--16 mb--16" />
                      }
                    </ng-template>
                  </p-timeline>
                } @else {
                  <!-- Add empty state-->
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
